// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import {
  defineRepositoryItemId,
  type RepositoryItemId,
  type RepositoryItemIdString
} from 'cadenza/repository/model/repository-item-id';

/** @see net/disy/cadenza/repository/api/workbook/WorkbookId.java */
export type WorkbookId = RepositoryItemId<'WORKBOOK'>;
/** @see net/disy/cadenza/repository/api/workbook/WorkbookId.java */
export const WorkbookId = defineRepositoryItemId('WORKBOOK');
/**
 * @knipignore
 * @see net/disy/cadenza/repository/api/workbook/WorkbookId.java
 */
export type WorkbookIdString = RepositoryItemIdString<'WORKBOOK'>;

// </GENERATED-CODE>
